module.exports = __webpack_public_path__ + "media/images/article/2021_head-a568b94f8d027f50babb59ad7e709171.jpg";